import { ArrowForward } from "@mui/icons-material";
import { Divider, List, ListItem, ListItemText, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";

const StyledPaper = styled(Paper)({
    marginBottom: "12px",
    width: "84%",
    marginLeft: "8%",
    backgroundColor: "rgba(255, 255, 255, 0.13)",
    marginTop: 16,
    borderRadius: "6px",
});

const StyledListTitle = styled("h3")({
    margin: 0,
    paddingLeft: 16,
    fontSize: "17px",
    color: "white",
});

const StyledHelpTitle = styled("h3")({
    margin: 0,
    paddingLeft: 10,
    fontSize: "17px",
    color: "white",
});

const StyledLink = styled(Link)({
    textDecoration: "none",
    "&:focus": {
        textDecoration: "none",
    },
});

const StyledListItem = styled(ListItem)({
    "&:hover": {
        cursor: "pointer",
        backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
});

const StyledListItemText = styled(ListItemText)({
    "& .MuiListItemText-primary": {
        color: "white",
        fontWeight: 400,
        fontSize: "13px",
    },
});

const StyledArrowForward = styled(ArrowForward)({
    color: "white",
    marginRight: "6px",
});

const StyledHelpMsg = styled("div")({
    color: "white",
    fontWeight: 400,
    fontSize: "13px",
    margin: 0,
    padding: 10,
    "& a": {
        color: "white",
        fontWeight: 400,
        fontSize: "13px",
    },
});

const MoreDrawerLinks = () => {
    const handleLinkClick = (title, url) => {
        ReactGA.event("KM Toolbox Click", {
            destination: title,
        });
        window.open(url);
    };

    return (
        <React.Fragment>
            <StyledPaper>
                <List disablePadding component="nav">
                    <ListItem divider disableGutters>
                        <StyledListTitle>KM Toolbox</StyledListTitle>
                        <Divider />
                    </ListItem>

                    <StyledLink to="/training-content">
                        <StyledListItem
                            divider
                            button
                            disableGutters
                            onClick={() => ReactGA.event("KM Toolbox Click", { destination: "Training Content" })}
                        >
                            <StyledListItemText primary="Training Content" />
                            <StyledArrowForward />
                        </StyledListItem>
                    </StyledLink>

                    <StyledListItem
                        divider
                        button
                        disableGutters
                        onClick={() =>
                            handleLinkClick(
                                "FAQ",
                                "https://s3.us-east-2.amazonaws.com/connect.kidder.com/downloads/KM+Connect+Q+%26+A.docx"
                            )
                        }
                    >
                        <StyledListItemText primary="FAQ" />
                        <StyledArrowForward />
                    </StyledListItem>

                    <StyledListItem
                        divider
                        button
                        disableGutters
                        onClick={() =>
                            handleLinkClick("Research Reports", "http://www.kiddermathews.com/research.php", "_blank")
                        }
                    >
                        <StyledListItemText primary="Research Reports" />
                        <StyledArrowForward />
                    </StyledListItem>

                    <StyledListItem
                        divider
                        button
                        disableGutters
                        onClick={() =>
                            handleLinkClick("PowerBI Reports", "https://app.powerbi.com/sharedwithme", "_blank")
                        }
                    >
                        <StyledListItemText primary="Power BI Reports" />
                        <StyledArrowForward />
                    </StyledListItem>

                    <StyledListItem
                        divider
                        button
                        disableGutters
                        onClick={() =>
                            handleLinkClick(
                                "Helpful Links",
                                "https://s3.us-east-2.amazonaws.com/connect.kidder.com/downloads/KM+Connect+Helpful+Links.xlsx",
                                "_blank"
                            )
                        }
                    >
                        <StyledListItemText primary="Helpful Links" />
                        <StyledArrowForward />
                    </StyledListItem>
                </List>
            </StyledPaper>
            <StyledPaper>
                <List disablePadding component="nav">
                    <ListItem divider disableGutters>
                        <StyledHelpTitle>Need Assistance?</StyledHelpTitle>
                        <Divider />
                    </ListItem>
                </List>
                <StyledHelpMsg>
                    Please call the KM Connect helpline at
                    <br />
                    206-248-3825 or email the support team at{" "}
                    <a href="mailto:KM_Connect@kidder.com">KM_Connect@kidder.com</a>
                </StyledHelpMsg>
            </StyledPaper>
        </React.Fragment>
    );
};

export default MoreDrawerLinks;
